import { useTranslation } from "react-i18next";
import { TabsContainer, TabsRoot, TopicTab } from "./CommunityTopicsTabs.styles";
import type { CommunityTopicResponse } from "../../queries/community.types";

type CommunityTopicsTabsProps = {
  topics: CommunityTopicResponse[];
  selectedTopics: string[];
  onTopicChange: (topicCode: string) => void;
};

export function CommunityTopicsTabs({
  topics,
  selectedTopics,
  onTopicChange
}: CommunityTopicsTabsProps) {
  const { t } = useTranslation();

  return (
    <TabsRoot>
      <TabsContainer
        variant="scrollable"
        scrollButtons={ true }
        allowScrollButtonsMobile
        value={ false }
        aria-label={ t("topic_list") }
      >
        { topics.map((topic) => (
          <TopicTab
            tabIndex={ 0 }
            key={ topic.code }
            label={ topic.name }
            value={ topic.code }
            aria-label={ topic.name }
            aria-pressed={ selectedTopics.includes(topic.code) }
            data-selected={ selectedTopics.includes(topic.code) }
            onClick={ () => onTopicChange(topic.code) }
            id={ `community-tab-${topic.code}` }
          />
        )) }
      </TabsContainer>
    </TabsRoot>
  );
}
